import React, { useEffect } from 'react'
import Nav from '../components/nav/Nav';
import SiteMapContainer from '../containers/SiteMap';

const SiteMap: React.FC= () => {

  useEffect(()=>{
    document.title = 'Elite Community Credit Union | Site Map'
  }, [])

  return (
    <div>
      <Nav />
      <SiteMapContainer />
    </div>
  )
}

export default SiteMap